import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import SweetAlert from 'sweetalert-react';

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
  LanguageSelect,
} from 'C4';
import { storageKeys, bgVideo } from 'settings';

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '1993-01-10',
      appId: -1,
      userStatus: 'startTraining',
      popup: false,
      logo: null,
      logoWhite: null,
      landingQuote: null,
    };
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res.training_graduated) {
        return this.setState({ userStatus: 'graduated' });
      }
      if (res.training_started) {
        return this.setState({ userStatus: 'continueTraining' });
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = val => `0${val}`.slice(-2);

    StorageHandler.load(storageKeys.user).then((user) => {
      if (user && user.sales_companion_registered === null) {
        const obj = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.updateUser(appId, obj.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        });
      }
    });

    this.getAppInfo();
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logo,
        logoWhite: appInfo.logoWhite,
        landingQuote: appInfo.landingQuote,
      });
    }
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages,
    ).then((res) => {
      this.setState({ unreadMessageCount: res.missed_items[0].count });
    });
  }

  render() {
    const {
      userStatus,
      popup,
      logo,
      logoWhite,
      landingQuote,
      unreadMessageCount,
    } = this.state;

    const close = () => {
      this.setState({
        popup: false,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo darken />}
        <div className="bgHome" />
        <div className="buttonWrapper">
          Download now:
          <StoreButtons />
        </div>
        <LanguageSelect />
        <div className="swoop" />
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {props => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <img src={logo} className="homeLogo" alt="logo" />
                <div className="homeView__title--action">
                  <form>
                    <Link
                      to="/main/search"
                      onClick={() => {
                        this.setQuery();
                      }}
                    >
                      <button type="submit" className="searchButton">
                        <FontAwesomeIcon icon={['fas', 'search']} />
                      </button>
                    </Link>
                    <input
                      type="text"
                      placeholder={i18n.translate('general.search')}
                      onChange={(e) => {
                        const { value } = e.target;
                        this.setState({ query: value });
                      }}
                    />
                    {/* <Link
                      to='/main/search'
                      onClick={() => {
                        this.setQuery();
                      }}
                    >
                      <button type='submit' className='searchButton'>
                        <FontAwesomeIcon icon={['fas', 'search']} />
                      </button>
                    </Link> */}
                  </form>
                  <div className="homepage__buttons">
                    <Link to="/main/messages" className="messageBtn">
                      {unreadMessageCount > 0 && (
                        <p>
                          <FontAwesomeIcon icon={['fas', 'envelope']} />
                          {i18n.translate('nav.messages')} ({unreadMessageCount}
                          )
                        </p>
                      )}
                      {unreadMessageCount == 0 && (
                        <p>
                          <FontAwesomeIcon icon={['fas', 'envelope']} />
                          {i18n.translate('nav.messages')}
                        </p>
                      )}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Spring>
        {/* <div className="top-bar" />
        <div className="bottom-bar" />
        <div className="bottom-bg" /> */}
        <div className="bottomLine" />
        <SweetAlert
          title={i18n.translate('homeScreen.popup.title')}
          show={popup}
          imageUrl={logo}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text={i18n.translate('homeScreen.popup.body', {
            Link: `<a href='/main/sell'>${i18n.translate('homeScreen.popup.sellSection')}</a>`,
          })}
          customClass="popup"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        />
      </div>
    );
  }
}
